module.exports = __webpack_public_path__ + "img/gabarito-2.5a57e3cf.png";